import axios from "axios";
const {REACT_APP_CHECK_SEUIL_API_URL, REACT_APP_CHECK_BUDGET_API_URL} = process.env;

export class BudgetService {
    isEnoughSeuil(codeDelegation, exercice, montant) {
        return axios.get(REACT_APP_CHECK_SEUIL_API_URL + "?codeDelegation=" + codeDelegation + "&exercice=" + exercice+ "&montant=" + montant);
    }

    isEnoughBudget(codeDelegation, exercice, montant) {
        return axios.get(REACT_APP_CHECK_BUDGET_API_URL + "?codeDelegation=" + codeDelegation + "&exercice=" + exercice+ "&montant=" + montant);
    }
}
